export default "__VITE_ASSET__f573bcb2__"